<script lang="ts">
  import SlipTable from './SlipTable.svelte';
  import { slipTypeChoice } from './config/store';
  import type { ChoiceDisplayMap } from 'scripts/utils/types';

  export let choiceDisplayMap: ChoiceDisplayMap = {};
  export let slipList = [];

  const tabs = Object.values($slipTypeChoice);
</script>

<SlipTable bind:slipList bind:choiceDisplayMap />
